import React from 'react';
import PropTypes from 'prop-types';

import styles from '../../testOverview.scss';

/**
 * IconSelect is a component that wraps around a select element.
 *
 * icon should represent a FontAwesome class name without the "fa-" prefix.
 */
class IconSelect extends React.PureComponent {
    static propTypes = {
        icon: PropTypes.string.isRequired,
        children: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.arrayOf(PropTypes.element),
        ]).isRequired,
    };

    render() {
        const { children, icon } = this.props;

        return (
            <div className={styles.IconSelect}>
                {children}
                <i className={`fa fa-${icon}`} aria-hidden />
            </div>
        );
    }
}

export default IconSelect;
